import React from "react"
import { Formik, Form } from "formik"
import { FormControl, Typography, Box, Stack } from "@mui/material"
import { getDistributionCenterProductTypes, getInitialAttachRates } from "../../../../../utils/distributionCenter"
import FormikNumberField from "../../../../../components/form/FormikNumberField"
import { COLORS } from "../../../../../utils"

export const distributionCenterProductTypeSettingsFormId = "distributionCenterProductTypeSettingsFormId"

const DistributionCentersProductTypeSettingsForm = ({ distributionCenter, handleSubmit, productTypeOptions }) => {

  const formatNumber = (value) => {
    if (!value.match(new RegExp(/^\d*(\.\d{0,2})?$/))) value = (value && value.slice(0, -1)) || 0
    return value
  }

  const handleFieldChange = (event, setFieldValue, path) => {
    const formatted = formatNumber(event.target.value)
    const newValue = formatted === "" ? null : Number(formatted)
    setFieldValue(path, newValue)
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{
        attachRates: distributionCenter.attachRates || getInitialAttachRates(productTypeOptions),
        dispatch: distributionCenter.dispatch || {}
      }}
      >
      {({ values, handleBlur, setFieldValue }) => (
        <Form id={distributionCenterProductTypeSettingsFormId}>
        <Stack spacing={4}>
          {getDistributionCenterProductTypes(productTypeOptions, ["ALL"]).map(({ label, value }) => (
            <Box key={value} m={0}>
              {/* Top row */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} mt={0}>
                <Typography fontSize="16px" fontWeight={500} lineHeight="18px" color={COLORS.BLACK}>
                  {label}
                </Typography>
              </Box>

              {/* Form row */}
              <Box display="flex" gap={2} mb={1}>
                {/* Attach rate */}
                <FormControl variant="standard">
                  <FormikNumberField
                    name={`attachRates.${value}`}
                    label="Taux de rattachement"
                    disabled={label === "Plat"}
                    value={values.attachRates?.[value] ?? ""}
                    onChange={(e) => handleFieldChange(e, setFieldValue, `attachRates.${value}`)}
                    onBlur={handleBlur}
                  />
                </FormControl>

                {/* Reusable percentage */}
                <FormControl variant="standard" sx={{ flex: 1 }}>
                  <FormikNumberField
                    name={`dispatch.${value}.reusable`}
                    label="Pourcentage réutilisable"
                    value={values.dispatch?.[value]?.reusable ?? ""}
                    onChange={(e) => handleFieldChange(e, setFieldValue, `dispatch.${value}.reusable`)}
                    onBlur={handleBlur}
                  />
                </FormControl>

                {/* Minimum */}
                <FormControl variant="standard" sx={{ flex: 1 }}>
                  <FormikNumberField
                    name={`dispatch.${value}.min`}
                    label="Minimum"
                    endAdornment=""
                    value={values.dispatch?.[value]?.min ?? ""}
                    onChange={(e) => handleFieldChange(e, setFieldValue, `dispatch.${value}.min`)}
                    onBlur={handleBlur}
                  />
                </FormControl>

                {/* Maximum */}
                <FormControl variant="standard" sx={{ flex: 1 }}>
                  <FormikNumberField
                    name={`dispatch.${value}.max`}
                    label="Maximum"
                    endAdornment=""
                    value={values.dispatch?.[value]?.max ?? ""}
                    onChange={(e) => handleFieldChange(e, setFieldValue, `dispatch.${value}.max`)}
                    onBlur={handleBlur}
                  />
                </FormControl>
              </Box>
            </Box>
          ))}
        </Stack>
      </Form>
    )}
  </Formik>
  )
}

export default DistributionCentersProductTypeSettingsForm